import { useEffect, useRef, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { BellOff } from 'lucide-react';
import { kalenderAbbestellen } from '@/api/calendar.api';

/**
 * Ziel des Abbestell-Links aus der Erinnerungsmail. Ohne Anmeldung: wer
 * abbestellen will, tut es in dem Moment, in dem ihn die Mail stört.
 */
export function KalenderAbbestellenPage() {
  const { token = '' } = useParams();
  const [zustand, setZustand] = useState<'laeuft' | 'fertig' | 'fehler'>('laeuft');
  const [baum, setBaum] = useState<string | null>(null);
  const [fehler, setFehler] = useState('');
  // StrictMode ruft Effekte doppelt auf – abbestellen soll trotzdem nur einmal.
  const gesendet = useRef(false);

  useEffect(() => {
    if (gesendet.current) return;
    gesendet.current = true;
    kalenderAbbestellen(token)
      .then((r) => {
        setBaum(r.baum);
        setZustand('fertig');
      })
      .catch((e: Error) => {
        setFehler(e.message);
        setZustand('fehler');
      });
  }, [token]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 p-4">
      <div className="w-full max-w-sm rounded-2xl border border-slate-200 bg-white p-6 text-center shadow-sm">
        <div className="mx-auto mb-3 flex h-11 w-11 items-center justify-center rounded-full bg-slate-100 text-slate-500">
          <BellOff className="h-5 w-5" aria-hidden="true" />
        </div>
        {zustand === 'laeuft' && <p className="text-sm text-slate-500">Einen Moment …</p>}
        {zustand === 'fertig' && (
          <>
            <h1 className="text-base font-semibold text-slate-900">Erinnerungen abbestellt</h1>
            <p className="mt-1 text-sm text-slate-500">
              Du bekommst keine Kalender-Mails mehr{baum ? <> zu „{baum}"</> : null}. Wieder einschalten kannst du sie
              jederzeit im Kalender unter „Erinnerungen".
            </p>
          </>
        )}
        {zustand === 'fehler' && (
          <>
            <h1 className="text-base font-semibold text-slate-900">Das hat nicht geklappt</h1>
            <p className="mt-1 text-sm text-slate-500">{fehler}</p>
          </>
        )}
        <Link to="/calendar" className="mt-5 inline-block text-sm font-medium text-blue-600 hover:underline">
          Zum Kalender
        </Link>
      </div>
    </div>
  );
}
